import React from "react"
import { graphql } from "gatsby"
import Img from "gatsby-image"
import styled, { keyframes } from "styled-components"

import Reveal from "components/utils/Reveal"

import Box from "components/atoms/Box"

const fadeIn = keyframes`
 0% { opacity: 0;  }
 100% { opacity: 1; }
`

const Wrapper = styled.div`
  position: relative;
`

const BackImage = styled.div`
  animation: ${fadeIn} 0.75s 0.25s ease-in-out both;
`

const FrontImage = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  animation: ${fadeIn} 0.75s 0.75s ease-in-out both;
`

const LayeredImage = ({ backImage, frontImage }) => {
  return (
    <Wrapper>
      <BackImage>
        <Img
          fluid={backImage.fluid}
          alt={backImage.description}
          loading="eager"
          fadeIn={false}
        />
      </BackImage>
      <FrontImage>
        <Img
          fluid={frontImage.fluid}
          alt={frontImage.description}
          loading="eager"
          fadeIn={false}
        />
      </FrontImage>
    </Wrapper>
  )
}

export default LayeredImage

export const query = graphql`
  fragment LayeredImage on ContentfulLayeredImage {
    backImage {
      description
      fluid(maxWidth: 500, quality: 90) {
        ...GatsbyContentfulFluid
      }
    }
    frontImage {
      description
      fluid(maxWidth: 500, quality: 90) {
        ...GatsbyContentfulFluid
      }
    }
  }
`
